// src/pages/ForgetPassword.jsx
import React from 'react';
import { Link } from 'react-router-dom';
import emailIcon from '../assets/email.png';
import backgroundImage from '../assets/back.jpg';

const ForgetPassword = () => {
  return (
    <div className="relative min-h-screen flex flex-col items-center justify-center px-4 py-12" style={{ fontFamily: 'var(--font-body)' }}>
      {/* Background photo, tied to the palette with a duotone overlay */}
      <div
        className="absolute inset-0 bg-cover bg-center -z-10"
        style={{ backgroundImage: `url(${backgroundImage})` }}
      />
      <div
        className="absolute inset-0 -z-10"
        style={{ background: 'linear-gradient(160deg, rgba(22,38,43,0.85) 0%, rgba(14,124,123,0.55) 100%)' }}
      />

      <div className="bg-white/95 backdrop-blur-sm border border-[var(--mist)] shadow-xl p-8 rounded-3xl w-full max-w-md">
        <span
          className="block text-[var(--coral)] text-xs tracking-[0.2em] uppercase text-center mb-2"
          style={{ fontFamily: 'var(--font-mono)' }}
        >
          Account Recovery
        </span>
        <h2
          className="text-3xl font-medium text-center text-[var(--ink)] mb-6"
          style={{ fontFamily: 'var(--font-display)' }}
        >
          Forgot Password
        </h2>

        <form id="form" action="/action_page.php" autoComplete="off" method="post">
          <p className="text-[var(--ink)]/70 text-center mb-6">
            Enter the email address associated with your account and we'll send you a link to reset your password
          </p>
          <div className="mb-6">
            <label htmlFor="email" className="block text-[var(--ink)] text-sm font-medium mb-2">Email</label>
            <div className="relative">
              <img src={emailIcon} className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 opacity-60" alt="" />
              <input
                id="email"
                name="email"
                type="email"
                placeholder="name123@gmail.com"
                required
                className="w-full pl-11 pr-4 py-2.5 border border-[var(--mist)] rounded-xl focus:outline-none focus:ring-2 focus:ring-[var(--teal)] transition-shadow"
              />
            </div>
            <div className="text-[var(--coral)] text-sm mt-1"></div>
          </div>
          <div className="flex justify-between gap-3 mt-8">
            <Link
              to="/create-password"
              className="flex-1 bg-[var(--teal)] hover:bg-[var(--teal-deep)] text-white font-medium py-2.5 px-4 rounded-full text-center transition-colors duration-200"
            >
              Send Email
            </Link>
            <Link
              to="/login"
              className="flex-1 bg-white border border-[var(--mist)] hover:bg-[var(--mist)]/50 text-[var(--ink)] font-medium py-2.5 px-4 rounded-full text-center transition-colors duration-200"
            >
              Cancel
            </Link>
          </div>
          <div className="text-center mt-4 text-[var(--ink)]/70 text-sm">
            Need an account?{' '}
            <Link to="/signup" className="text-[var(--teal-deep)] font-medium hover:underline">Sign up</Link>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ForgetPassword;
